import { render } from "./GSLogin.vue?vue&type=template&id=a838c63a"
import script from "./GSLogin.vue?vue&type=script&lang=js"
export * from "./GSLogin.vue?vue&type=script&lang=js"
script.render = render

export default script